// @flow

// Effect Managers
import { all, call, fork, take } from 'redux-saga/effects'

// Action type

import {
  FETCH_COMMENTS,
  FETCH_HEFTY_CROPS,
} from '../constants'

// Controller
import commentsCtrl from 'hfty-ctrl-comments'
import { controller as cropController } from 'fc-model-crops'

// Exports
export default function *main (): Generator<*, *, *> {
  yield all([
    call(commentsCtrl.start),
    call(cropController.start),
  ])

  yield fork(commentsCtrl.watch)
  yield fork(cropController.watch)

  // yield fork(watchFetchComments)
  yield fork(fetchComments)

  // yield fork(watchFetchCrops)
  yield fork(fetchCrops)
}

export function *watchFetchComments (): Generator<*, *, *> {
  while (true) {
    yield take(FETCH_COMMENTS)
    yield call(commentsCtrl.read)
  }
}

export function *fetchComments (): Generator<*, *, *> {
  yield call(commentsCtrl.read)
}

export function *watchFetchCrops (): Generator<*, *, *> {
  while (true) {
    yield take(FETCH_HEFTY_CROPS)
    yield call(cropController.read, {
      queryParams: {
        hefty: 'True',
      },
    })
  }
}

export function *fetchCrops (): Generator<*, *, *> {
  yield call(cropController.read, {
    queryParams: {
      hefty: 'True',
    },
  })
}
